import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

export const PageErrorComponent = ({
    error,
    message = 'There are one or more errors on this page. Kindly fill the required details and verify them.',
}) => {
    const errorWithNilValuesRemoved = _.omitBy(error, _.isEmpty);

    return (
        <div>
            {!_.isEmpty(errorWithNilValuesRemoved) && (
                <span className="block py-1 pl-1 my-2 text-s text-center w-full text-red-700 bg-red-200">
                    {' '}
                    {message}{' '}
                </span>
            )}
        </div>
    );
};
PageErrorComponent.propTypes = {
    error: PropTypes.object,
    message: PropTypes.string,
};
